import React from 'react';
import { connect } from 'react-redux';
import {
  BrowserRouter,
  Switch,
} from "react-router-dom";
//===== IMPORT VIEWS ========
import Navigation from './Views/Navigation';


class App extends React.Component {
  render() {
    return (
      <div className="App">
        <BrowserRouter key="br3">
          <Switch>
            <Navigation />
          </Switch>
        </BrowserRouter>
      </div>
    )
  }
}

const mapStateToProps = ({ login }) => ({
  signIn: login.signIn
});

const mapDispatchToProps = (dispatch) => {
  return { signOut: () => dispatch({ type: "sign_out" }) };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
